import "./Contact.css";
import CTA from "../../components/CTA/CTA";
import Footer from "../../components/Footer/Footer";
import Hero from "./Hero/Hero";
import { Fade } from "react-reveal";

const Contact = () => {
  return (
    <Fade duration={250}>
      <div>
        <Hero />
        <Footer />
      </div>
    </Fade>
  );
};

export default Contact;
